import { FormatIcu } from '@tolgee/format-icu';
import { BackendFetch, DevTools, Tolgee } from '@tolgee/react';

const apiUrl = import.meta.env.VITE_APP_TOLGEE_API_URL;
const apiKey = import.meta.env.VITE_APP_TOLGEE_API_KEY;

export const tolgee = Tolgee()
  .use(DevTools())
  .use(FormatIcu())
  .use(
    BackendFetch({
      prefix: '/locales',
    }),
  )
  .init({
    language: 'fr-FR',
    fallbackLanguage: 'fr-FR',
    apiUrl,
    apiKey,
    availableLanguages: ['fr-FR'],
  });
